'use client';

import { useGateValue } from '@statsig/react-bindings';
import type { PropsWithChildren } from 'react';
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

export interface DecagonContextValues {
  isDecagonScriptLoaded: boolean;
  isChatbotEnabled: boolean;
  onScriptLoaded: () => void;
}

const DEFAULT_CONTEXT_VALUES: DecagonContextValues = {
  isDecagonScriptLoaded: false,
  isChatbotEnabled: false,
  onScriptLoaded: () => {},
};

export const DecagonContext = createContext<DecagonContextValues>(
  DEFAULT_CONTEXT_VALUES,
);

const DecagonProvider = ({ children }: PropsWithChildren) => {
  const [isDecagonScriptLoaded, setIsDecagonScriptLoaded] =
    useState<boolean>(false);
  const isChatbotEnabled = useGateValue('pdp_chatbot');

  const onScriptLoaded = useCallback(() => {
    setIsDecagonScriptLoaded(true);
  }, []);

  const value: DecagonContextValues = useMemo(
    () => ({
      isDecagonScriptLoaded,
      isChatbotEnabled,
      onScriptLoaded,
    }),
    [isDecagonScriptLoaded, isChatbotEnabled, onScriptLoaded],
  );

  return (
    <DecagonContext.Provider value={value}>{children}</DecagonContext.Provider>
  );
};

export const useDecagonContext = () => useContext(DecagonContext);

export default DecagonProvider;
